import './initIcon.js'

import './iconfont/iconfont.css'

import './iconfont_new/iconfont.css'
